// @ts-nocheck

import { actionTypes } from '../constants';

export const setSelectedBetGroupId = (betGroupId) => ({
  type: actionTypes.SET_SELECTED_BET_GROUP,
  payload: {
    betGroupId,
  },
});

export const resetPanelContent = () => ({
  type: actionTypes.RESET_PANEL_CONTENT,
});
